import React, { Suspense, useContext } from "react";

import { FormTypeEnum } from "@layout/modals/types";

import CashbackDetailsCard from "@/components/common/cashbackDetailsCard";
import Modal from "@/components/common/modal";
import { UrlParamKeyEnum } from "@/components/constants";
import PhoneModal from "@/components/modals/phoneModal";
import QuestionnaireModal from "@/components/modals/questionnaireModal";
import SupportModal from "@/components/modals/supportModal";
import VideoSessionErrorModal from "@/components/modals/videoSessionErrorModal";
import AuthorizationFormContext from "@/contexts/AuthorizationForm/AuthorizationFormContext";

import "../styles.scss";

/**
 * Онбординг грузим лениво (SEO #09/#04): модалка открывается по параметру в URL, то есть до
 * открытия не нужна вовсе, а её код и 13 иллюстраций (65 КБ) до этого ехали на КАЖДОЙ странице —
 * `CommonModals` монтируется в `Template` глобально. Вынос иконок здесь не помогал: они просто
 * переезжали между чанками, которые и так грузятся везде (см. `done/09b-icons-split.md` §4).
 *
 * `Suspense` с пустым фолбэком: в пререндере эта ветка не рендерится (в статике нет query-параметра),
 * а в браузере между кликом и появлением модалки добавляется загрузка одного чанка.
 */
const OnboardingModal = React.lazy(() =>
  import("@/components/modals/onboardingModal"));
/**
 * Modals used in many parts of the code
 * @returns
 */
const CommonModals = () => {
  const { formType } = useContext(AuthorizationFormContext);

  switch (formType) {
    case FormTypeEnum.Questionnaire:
      return (
        <Modal
          urlParamKey={UrlParamKeyEnum.LoginFormModal}
          header="Завершение регистрации"
          className="questionnaire styled-subtitle"
        >
          <QuestionnaireModal enableEmail enableBirthDate />
        </Modal>
      );
    case FormTypeEnum.BirthDateQuestionnaire:
      return (
        <Modal
          urlParamKey={UrlParamKeyEnum.LoginFormModal}
          header="Завершение регистрации"
          className="questionnaire styled-subtitle"
        >
          <QuestionnaireModal enableBirthDate />
        </Modal>
      );
    case FormTypeEnum.PhoneQuestionnaire:
      return (
        <Modal
          urlParamKey={UrlParamKeyEnum.LoginFormModal}
          header="Укажите номер телефона для связи с экспертом"
          className="questionnaire styled-subtitle"
        >
          <PhoneModal />
        </Modal>
      );
    case FormTypeEnum.CashBackInformation:
      return <CashbackDetailsCard />;
    case FormTypeEnum.Onboarding:
      return (
        <Suspense fallback={null}>
          <OnboardingModal urlParamKey={UrlParamKeyEnum.LoginFormModal} />
        </Suspense>
      );
    case FormTypeEnum.Support:
      return <SupportModal urlParamKey={UrlParamKeyEnum.LoginFormModal} />;
    case FormTypeEnum.VideoSessionError:
      return <VideoSessionErrorModal urlParamKey={UrlParamKeyEnum.LoginFormModal} />;
    default:
      return null;
  }
};

export default CommonModals;
